"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fileHelpers_1 = require("./fileHelpers");
var uploadStateEnum_1 = require("./uploadStateEnum");
var axiosHelper_1 = require("../util/axiosHelper");
var FileModel = /** @class */ (function () {
    function FileModel(file, 
    // public projectId: number | null,
    // public bucketId: number,
    state, uploadId, systemUser) {
        if (state === void 0) { state = uploadStateEnum_1.FILE_STATUS.STATIC; }
        if (uploadId === void 0) { uploadId = null; }
        if (systemUser === void 0) { systemUser = ""; }
        this.file = file;
        this.state = state;
        this.uploadId = uploadId;
        this.systemUser = systemUser;
        this.id = "_" + Math.random().toString(36).substr(2, 9);
        this.uploadProgress = 0;
        this.resizePollcount = 0;
        this.cancelToken = (0, axiosHelper_1.genCancelToken)();
        this.fileid = null;
        this.similarFile = file.similarFile || null;
    }
    FileModel.prototype.lastModified = function () {
        var _a;
        return (_a = this.file) === null || _a === void 0 ? void 0 : _a.lastModified;
    };
    FileModel.prototype.isValid = function (fileWhiteList) {
        return (0, fileHelpers_1.isFileValid)(this.file, this.mimeType(), fileWhiteList);
    };
    FileModel.prototype.mimeType = function () {
        if (["OBJ", "STL"].includes(this.file.name.split(".").pop().toUpperCase())) {
            return "text/plain";
        }
        return this.file.type;
    };
    FileModel.prototype.getVM = function () {
        return {
            id: this.id,
            name: this.file.name,
            state: this.state,
            uploadProgress: this.uploadProgress,
            resizePollcount: this.resizePollcount,
            uploadId: this.uploadId,
        };
    };
    FileModel.prototype.uploaded = function (uploadId, fileQueued, id, similarFile) {
        this.state = fileQueued
            ? uploadStateEnum_1.FILE_STATUS.FILE_UPLOADED
            : uploadStateEnum_1.FILE_STATUS.FILE_PROCESSED;
        this.uploadProgress = 100; //just to be sure
        this.uploadId = uploadId;
        this.fileid = id;
        this.similarFile = similarFile;
    };
    FileModel.prototype.polled = function () {
        this.resizePollcount++;
    };
    FileModel.prototype.reset = function () {
        this.state = uploadStateEnum_1.FILE_STATUS.STATIC;
        this.cancelToken = (0, axiosHelper_1.genCancelToken)();
    };
    FileModel.prototype.processed = function () {
        this.state = uploadStateEnum_1.FILE_STATUS.FILE_PROCESSED;
    };
    FileModel.prototype.forbidden = function () {
        this.state = uploadStateEnum_1.FILE_STATUS.FORBIDDEN;
    };
    FileModel.prototype.failed = function () {
        this.state = uploadStateEnum_1.FILE_STATUS.UPLOAD_FAILED;
    };
    FileModel.prototype.cancel = function () {
        if (this.state == 0) {
            this.state = uploadStateEnum_1.FILE_STATUS.CANCELLED;
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }
        }
    };
    return FileModel;
}());
exports.default = FileModel;
//# sourceMappingURL=fileModel.js.map